import { Outlet, useParams } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { Box, CircularProgress, Typography } from '@mui/material';
import { eventService } from '../services/tenant/eventService';
import { useEventGtm } from '../analytics/useEventGtm';
import type { TrackableEvent } from '../analytics/types';

export default function PublicEventLayout() {
  const { id, slug } = useParams();
  const idOrSlug = slug || id;

  const { data: event, isLoading, isError } = useQuery({
    queryKey: ['public-event', idOrSlug],
    queryFn: () => eventService.getPublic(idOrSlug!).then((response) => response.data as TrackableEvent),
    enabled: Boolean(idOrSlug),
  });

  useEventGtm(event);

  if (isLoading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh' }}>
        <CircularProgress />
      </Box>
    );
  }

  if (isError || !event) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh', p: 4 }}>
        <Typography color="error">Evento não encontrado</Typography>
      </Box>
    );
  }

  return <Outlet context={{ event }} />;
}
